import React, { Component } from "react";
import List from "@material-ui/core/List";
import Badge from "@material-ui/core/Badge";
import { withStyles, withTheme } from "@material-ui/core/styles";
import ItemAny from "../list-item/ItemAny";
import { Timeline, TimelineEvent } from "react-event-timeline";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import LinkIcon from "@material-ui/icons/Link";
import FormControl from "@material-ui/core/FormControl";
import axios from "../../AxiosClient";
import { useState, useEffect } from "react";
import DisplayUser from "../user/DisplayUser";
import Pagination from "@material-ui/lab/Pagination";
import { withTranslation } from "react-i18next";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import UserTeamPicker from "../required-reading/UserTeamPicker";
import { taxServiceClient } from "../../AxiosClient";
import Link from "@material-ui/core/Link";
import { withRouter } from "react-router";
import { connect } from "react-redux";

const styles = (theme) => ({
  iconSpan: {
    float: "right",
    "& > svg": {},
  },
  listItem: {
    display: "block",
    paddingRight: "3px",
  },
  iconStyle: {},
  bubbleStyle: {
    color: theme.palette.secondary.dark,
  },
  formControlLabel: { fontSize: theme.typography.pxToRem(14) },
  pgContainer: {
    display: "flex",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: "100%",
  },
  paginator: {
    "& > ul": {
      marginLeft: "auto",
      marginRight: "auto",
      display: "flex",
    },
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
  },
  detailContainer: {
    display: "flex",
    backgroundColor: theme.palette.grey[300],
  },
  noDetailContainer: {
    display: "flex",
  },
  settingsTable: {
    margin: 10,
    flex: 1,
  },
  timelineContainer: {
    width: "100%",
  },
});

function ListSearchHistoryItems(props) {
  const [searchedBy, setSearchedBy] = useState([]);
  const [searchGroupId] = useState(props.searchGroupId);
  const [results, setResults] = useState([]);
  const [showNoViews, setShowNoViews] = useState();
  const [filterSearchHistory, setFilterSearchHistory] = useState(
    props.filters ? props.filters.status : "ALL"
  );
  const [pageSize, setPageSize] = useState(5);
  const [pageNum, setPageNum] = useState(1);
  const [numPages, setNumPages] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [sort, setSort] = useState("");
  const [sortDirection, setSortDirection] = useState("DESC");
  const [incomingSearchedBy, setIncomingSearchedBy] = useState(
    props.filters ? props.filters.searchedBy : []
  );
  const [userList, setUserList] = useState([]);
  const [objectClass] = useState(props.objectClass);

  const [timelineColumns] = useState([
    {
      title: "searchhistory_lastsearched",
      column: "lastSearchedDate",
      sortable: false,
      default: true,
    },
  ]);

  const [documentColumns] = useState(
    objectClass ===
    "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface"
      ? [
          {
            title: "searchhistory_document_title",
            column: "title",
            sortable: true,
            default: false,
            isdate: false,
            isuser: false,
          },
          {
            title: "searchhistory_lastviewed",
            column: "lastViewed",
            sortable: true,
            default: true,
            isdate: true,
            isuser: false,
          },
          {
            title: "searchhistory_lastlinked",
            column: "lastLinked",
            sortable: true,
            default: false,
            isdate: true,
            isuser: false,
          },
          {
            title: "searchhistory_viewed_by_users",
            column: "viewedByUsers",
            sortable: true,
            default: false,
            isdate: false,
            isuser: false,
          },
          {
            title: "searchhistory_linked_by_users",
            column: "linkedByUsers",
            sortable: true,
            default: false,
            isdate: false,
            isuser: false,
          },
          {
            title: "searchhistory_times_viewed",
            column: "timesViewed",
            sortable: true,
            default: false,
            isdate: false,
            isuser: false,
          },
          {
            title: "searchhistory_times_linked",
            column: "timesLinked",
            sortable: true,
            default: false,
            isdate: false,
            isuser: false,
          },
        ]
      : [
          {
            title: "searchhistory_document_title",
            column: "title",
            sortable: true,
            default: false,
            isdate: false,
            isuser: false,
          },
          {
            title: "searchhistory_lastviewed",
            column: "lastViewed",
            sortable: true,
            default: true,
            isdate: true,
            isuser: false,
          },
          {
            title: "searchhistory_lastlinked",
            column: "lastLinked",
            sortable: true,
            default: false,
            isdate: true,
            isuser: false,
          },
          {
            title: "searchhistory_times_viewed",
            column: "timesViewed",
            sortable: true,
            default: false,
            isdate: false,
            isuser: false,
          },
          {
            title: "searchhistory_times_linked",
            column: "timesLinked",
            sortable: true,
            default: false,
            isdate: false,
            isuser: false,
          },
        ]
  );

  const [userColumns] = useState([
    {
      title: "searchhistory_user",
      column: "user",
      sortable: true,
      default: false,
      isuser: true,
    },
    {
      title: "searchhistory_lastsearched",
      column: "lastSearchedDate",
      sortable: true,
      default: true,
      isdate: true,
      isuser: false,
    },
    {
      title: "searchhistory_total_searches",
      column: "totalSearches",
      sortable: true,
      default: false,
      isdate: false,
      isuser: false,
    },
    {
      title: "searchhistory_documents_viewed",
      column: "totalViews",
      sortable: true,
      default: false,
      isdate: false,
      isuser: false,
    },
    {
      title: "searchhistory_documents_used",
      column: "totalUsed",
      sortable: true,
      default: false,
      isdate: false,
      isuser: false,
    },
  ]);

  useEffect(
    () => {
      setPageNum(1);
    },
    [
      searchedBy,
      searchGroupId,
      filterSearchHistory,
      activeTab,
      sort,
      sortDirection,
    ]
  );
  useEffect(
    () => {
      getData();
    },
    [
      searchedBy,
      searchGroupId,
      pageNum,
      filterSearchHistory,
      activeTab,
      sort,
      sortDirection,
      objectClass,
    ]
  );
  useEffect(
    () => {
      props.currentUser.userPermits.roles.teamLeader ||
      props.currentUser.userPermits.roles.systemManager
        ? getUserData()
        : setSearchedBy(incomingSearchedBy);
    },
    [incomingSearchedBy]
  );
  const getSort = () => {
    let columns;
    if (activeTab === 0) {
      columns = timelineColumns;
    } else if (activeTab === 1) {
      columns = documentColumns;
    } else if (activeTab === 2) {
      columns = userColumns;
    }

    let defaultSort = columns
      .filter((el) => el.default === true)
      .map((el) => el.column)[0];
    return columns.map((el) => el.column).indexOf(sort) > -1
      ? sort
      : defaultSort;
  };
  const getUserData = () => {
    if (incomingSearchedBy && incomingSearchedBy.length > 0) {
      taxServiceClient
        .post("/user/userlist", { userIds: incomingSearchedBy })
        .then((res) => {
          setUserList(res.data);
        });
    }
  };
  const getData = () => {
    const prefix =
      objectClass ===
      "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface"
        ? "/searchhistory/searchgroup/allusers/"
        : "/searchhistory/searchgroup/";
    const pageToGet = pageNum - 1; //Pagination element index starts from 1 so adjust
    const url =
      activeTab === 0
        ? `${prefix}${searchGroupId}`
        : activeTab === 2
          ? `${prefix}usersummary/${searchGroupId}`
          : `${prefix}documentsummary/${searchGroupId}`;

    const sortToUse = getSort();

    let parameters = {};
    parameters.size = pageSize;
    parameters.page = pageToGet;
    parameters.sort = sortToUse;
    parameters.sortDirection = sortDirection;
    parameters.status = filterSearchHistory;
    parameters.searchedBy = searchedBy;

    axios.post(url, parameters).then((res) => {
      setResults(res.data.content);
      setNumPages(res.data.totalPages);
    });
  };

  const handlePageChange = (e, page) => {
    setPageNum(page);
  };
  const handleSearchHistoryFilterChange = (evt) => {
    setFilterSearchHistory(evt.target.value);
  };
  const handleTabChange = (_e, value) => {
    activeTab !== value && setResults([]);
    setActiveTab(value);
  };
  const onUserListUpdate = (newUsers) => {
    setSearchedBy(newUsers.map((u) => u.userId));
  };

  const documentClickFn = (item) => {
    props.history.push(`/full/document/${item.documentId}`);
  };

  const userClickFn = function(item) {
    setUserList([item.user]);
    setSearchedBy([item.user.userId]);

    handleTabChange({}, 0);
  };

  const getDefaultSort = () => {
    let columns;
    if (activeTab === 0) {
      columns = timelineColumns;
    } else if (activeTab === 1) {
      columns = documentColumns;
    } else if (activeTab === 2) {
      columns = userColumns;
    }

    return columns
      .filter((el) => el.default === true)
      .map((el) => el.column)[0];
  };

  const getTitle = (item) => {
    const { classes, theme } = props;
    return (
      <div>
        <div
          style={{ marginTop: theme.spacing(1), marginRight: theme.spacing(3) }}
        >
          {'"' + item.searchString + '"'}
        </div>
        <div
          style={{
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            marginRight: theme.spacing(3),
          }}
        >
          <DisplayUser userId={item.user.userId} user={item.user} />
        </div>
        {item.views.length > 0 || item.used.length > 0 ? (
          <div style={{ display: "flex" }}>
            <div
              style={{
                marginTop: theme.spacing(1),
                marginRight: theme.spacing(3),
              }}
            >
              {item.views.length > 0
                ? props.t("settings_searchhistory_documents_viewed") +
                  " " +
                  item.views.length
                : props.t("settings_searchhistory_documents_used") +
                  " " +
                  item.used.length}
            </div>
            <div>
              {item.used.length > 0 ? (
                <Badge badgeContent={item.used.length} color="primary">
                  <LinkIcon />
                </Badge>
              ) : (
                <></>
              )}
            </div>
          </div>
        ) : (
          <div>
            {props.t("settings_searchhistory_no_documents_viewed") +
              item.numberOfResults +
              props.t("settings_searchhistory_results_found")}
          </div>
        )}
      </div>
    );
  };
  const renderTimelineItem = (item) => {
    const title = getTitle(item);
    return (
      <>
        <TimelineEvent
          // style={{
          //   cursor: "auto",
          // }}
          // lineStyle={{
          //   cursor: "auto",
          // }}
          // contentStyle={{
          //   cursor: "auto",
          // }}
          // subtitleStyle={{
          //   cursor: "auto",
          // }}
          // cardHeaderStyle={{
          //   cursor: "auto",
          // }}

          title={title}
          titleStyle={{
            fontWeight: item.views.length > 0 ? "bold" : "normal",
            cursor: "auto",
          }}
          createdAt={
            <div style={{ cursor: "auto" }}>
              {moment(item.createdDate).format("DD/MM/YYYY HH:mm:ss")}
            </div>
          }
          icon={<SearchIcon />}
          iconStyle={{ color: theme.palette.secondary.dark, cursor: "auto" }}
          bubbleStyle={{
            borderColor: theme.palette.secondary.dark,
            backgroundColor: theme.palette.common.white,
          }}
          collapsible={true}
        >
          {(item.views.length > 0 || item.used.length > 0) && (
            <List>
              {item.views.map((viewItem, viewIdx) => {
                return (
                  <div>
                    <ItemAny
                      key={`${viewIdx}-${moment(viewItem.createdDate).format(
                        "DD/MM/YYYY HH:mm:ss"
                      )}`}
                      data={{
                        type: "search",
                        id: viewItem.documentId,
                        itemData: viewItem,
                      }}
                    />
                  </div>
                );
              })}
              {item.views.length === 0 &&
                item.used.length > 0 && (
                  <>
                    {item.used.map((usedItem, usedIdx) => {
                      return (
                        <div>
                          <ItemAny
                            key={`${usedIdx}-${moment(
                              usedItem.createdDate
                            ).format("DD/MM/YYYY HH:mm:ss")}`}
                            data={{
                              type: "search",
                              id: usedItem.documentId,
                              itemData: usedItem,
                            }}
                          />
                        </div>
                      );
                    })}
                  </>
                )}
            </List>
          )}
        </TimelineEvent>
      </>
    );
  };
  const renderItem = (item, columns, clickFn) => {
    return (
      <TableRow>
        {columns.map((d) => {
          return (
            <TableCell>
              <Link
                href="javascript:void(0)"
                underline="none"
                color="textPrimary"
                onClick={() => {
                  clickFn(item);
                }}
              >
                {d.isdate === true && item[d.column] ? (
                  moment(item[d.column]).format("DD/MM/YYYY HH:mm:ss")
                ) : d.isuser ? (
                  <DisplayUser
                    user={item[d.column]}
                    userId={item[d.column].userId}
                  />
                ) : (
                  item[d.column]
                )}
              </Link>
            </TableCell>
          );
        })}
      </TableRow>
    );
  };
  const getTableSort = (label, columns) => {
    const column = columns.filter((d) => d.title === label)[0];
    const sortable = column.sortable;
    const sortThis = column.column;
    return sortable === true ? (
      <TableSortLabel
        active={sort === "" ? getDefaultSort() === sortThis : sort === sortThis}
        direction={
          sortDirection ? sortDirection.toLowerCase() : "ASC".toLowerCase()
        }
        onClick={() => {
          sort === sortThis
            ? setSortDirection(sortDirection === "ASC" ? "DESC" : "ASC")
            : setSort(sortThis);
        }}
      >
        {t(label)}
      </TableSortLabel>
    ) : (
      <>{t(label)}</>
    );
  };
  const { classes, theme, t } = props;
  return (
    <div
      className={
        props.isportlet ? classes.noDetailContainer : classes.detailContainer
      }
    >
      <TableContainer component={Paper} className={classes.settingsTable}>
        <div
          style={{
            marginLeft: theme.spacing(3),
            marginRight: theme.spacing(3),
          }}
        >
          <>
            {objectClass ===
              "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface" &&
            (props.currentUser.userPermits.roles.teamLeader ||
              props.currentUser.userPermits.roles.systemManager) &&
            props.fullscreen === true ? (
              <div style={{ marginLeft: "auto", marginRight: "auto" }}>
                <UserTeamPicker
                  usersOnly={true}
                  onTeamUsersUpdate={onUserListUpdate}
                  onUsersUpdate={onUserListUpdate}
                  userHeaderKey="Select a user to filter"
                  userTeamHeaderKey="create_message_users_team_header"
                  asChips
                  loadUsers={userList.length > 0 ? userList : null}
                  hideNoUsersMessage={true}
                />
              </div>
            ) : (
              <></>
            )}
            <div style={{ overflow: "auto", margin: theme.spacing(2) }}>
              <>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  variant="fullWidth"
                >
                  <Tab label={t("searchhistory_timeline")} id="timeline-tab" />
                  <Tab
                    label={t("searchhistory_viewed_and_linked")}
                    id="viewed-linked-tab"
                    disabled={
                      props.linked === 0 && props.viewed === 0 ? true : false
                    }
                  />
                  {objectClass ===
                  "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface" ? (
                    <Tab
                      label={t("searchhistory_usersummary")}
                      id="usersummary-tab"
                    />
                  ) : (
                    <></>
                  )}
                </Tabs>
                {activeTab === 0 && (
                  <>
                    <div className={classes.pgContainer}>
                      <div style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <div
                          style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            marginTop: theme.spacing(2),
                          }}
                        >
                          <FormControl>
                            <RadioGroup
                              aria-label={t("searchhistory_search_filter")}
                              name="filter"
                              value={filterSearchHistory}
                              row="true"
                              onChange={handleSearchHistoryFilterChange}
                            >
                              <FormControlLabel
                                value="ALL"
                                control={<Radio />}
                                label={t("filter_discussions_all")}
                                classes={{ label: classes.formControlLabel }}
                              />
                              <FormControlLabel
                                value="LINKS_ONLY"
                                control={<Radio />}
                                label={t("filter_searches_attached_only")}
                                classes={{ label: classes.formControlLabel }}
                              />
                              <FormControlLabel
                                value="VIEWS_ONLY"
                                control={<Radio />}
                                label={t("filter_searches_views_only")}
                                classes={{ label: classes.formControlLabel }}
                              />
                              <FormControlLabel
                                value="NO_VIEWS_NO_LINKS"
                                control={<Radio />}
                                label={t("filter_searches_no_views_or_links")}
                                classes={{ label: classes.formControlLabel }}
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                        <div
                          style={{ marginLeft: "auto", marginRight: "auto" }}
                        >
                          <Pagination
                            className={classes.paginator}
                            size="small"
                            showFirstButton={true}
                            showLastButton={true}
                            count={numPages}
                            page={pageNum}
                            onChange={handlePageChange}
                            siblingCount={0}
                            boundaryCount={1}
                            color="primary"
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className={classes.pgContainer}> */}
                    <Timeline style={{ width: "100%" }}>
                      {results.map((item, idx) => {
                        return renderTimelineItem(item);
                      })}
                    </Timeline>
                    {/* </div> */}
                  </>
                )}
                {activeTab === 1 && (
                  <>
                    <div className={classes.pgContainer}>
                      <div style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <Pagination
                          className={classes.paginator}
                          size="small"
                          showFirstButton={true}
                          showLastButton={true}
                          count={numPages}
                          page={pageNum}
                          onChange={handlePageChange}
                          siblingCount={0}
                          boundaryCount={1}
                          color="primary"
                        />
                      </div>
                    </div>
                    <Table>
                      <TableHead>
                        {documentColumns.map((d, idx) => {
                          return (
                            <TableCell>
                              {getTableSort(d.title, documentColumns)}
                            </TableCell>
                          );
                        })}
                      </TableHead>
                      <TableBody>
                        {results.map((item, idx) => {
                          return renderItem(
                            item,
                            documentColumns,
                            documentClickFn
                          );
                        })}
                      </TableBody>
                    </Table>
                  </>
                )}
                {activeTab === 2 && (
                  <>
                    <div className={classes.pgContainer}>
                      {/* <FormControl component="fieldset"> */}
                      <div style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <Pagination
                          className={classes.paginator}
                          size="small"
                          showFirstButton={true}
                          showLastButton={true}
                          count={numPages}
                          page={pageNum}
                          onChange={handlePageChange}
                          siblingCount={0}
                          boundaryCount={1}
                          color="primary"
                        />
                      </div>
                      {/* </FormControl> */}
                    </div>
                    <Table>
                      <TableHead>
                        {userColumns.map((d, idx) => {
                          return (
                            <TableCell>
                              {getTableSort(d.title, userColumns)}
                            </TableCell>
                          );
                        })}
                      </TableHead>
                      <TableBody>
                        {results.map((item, idx) => {
                          return renderItem(item, userColumns, userClickFn);
                        })}
                      </TableBody>
                    </Table>
                  </>
                )}
              </>
            </div>
          </>
        </div>
      </TableContainer>
    </div>
  );
}
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTheme(
    withStyles(styles)(withRouter(withTranslation()(ListSearchHistoryItems)))
  )
);
